import { useContext } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import { Theme } from "@mui/material/styles";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import typography from "assets/theme/base/typography";

import { LanguageContext } from "context";

// Propsの型定義を追加
interface Props {
  light?: boolean;
  links?: {
    href: string;
    name: string;
  }[];
}

const defaultLinks = [
  { href: "https://chronospark.jp/privacy/", name: "footer.privacy" },
  { href: "https://chronospark.jp/terms/", name: "footer.terms" },
];

function Footer({ light = false, links = defaultLinks }: Props): JSX.Element {
  const { size } = typography;
  const { t } = useContext(LanguageContext) || { t: (k: string) => k };

  // リンクをレンダリングする関数を追加
  const renderLinks = () =>
    links.map((link) => (
      <MDBox key={link.name} component="li" px={2} lineHeight={1}>
        <Link href={link.href} target="_blank">
          <MDTypography
            variant="button"
            fontWeight="regular"
            color={light ? "white" : "text"} // lightモードに応じて文字色を変更
          >
            {t(link.name)}
          </MDTypography>
        </Link>
      </MDBox>
    ));

  return (
    <MDBox position="absolute" width="100%" bottom={0} py={4}>
      <Container>
        <MDBox
          width="100%"
          display="flex"
          flexDirection={{ xs: "column", lg: "row" }}
          justifyContent="space-between"
          alignItems="center"
          px={1.5}
        >
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
            color={light ? "white" : "text"}
            fontSize={size.sm}
          >
            &copy; {new Date().getFullYear()}, {t("footer.made_by")}
            <Link href="https://smart-beast-soft.com" target="_blank">
              <MDTypography variant="button" fontWeight="medium" color={light ? "white" : "dark"}>
                &nbsp;{t("footer.company")}&nbsp;
              </MDTypography>
            </Link>
            {t("footer.for_a_better_web")}
          </MDBox>
          <MDBox
            component="ul"
            sx={({ breakpoints }: Theme) => ({
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
              listStyle: "none",
              mt: 3,
              mb: 0,
              p: 0,

              [breakpoints.up("lg")]: {
                mt: 0,
              },
            })}
          >
            {/* リンク群を出力 */}
            {renderLinks()}
          </MDBox>
        </MDBox>
      </Container>
    </MDBox>
  );
}

export default Footer;
